"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7852],{

/***/ 82858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ loadAppointmentReasons; }
/* harmony export */ });
/* unused harmony export memoizedLoadApptReasonsExportedForTesting */
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56776);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34557);
/* harmony import */ var _utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54428);




function loadAppointmentReasons() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    return memoizedLoadApptReasonsExportedForTesting(practiceId, video, instant).catch(()=>[]);
}
// Exported only for testing. Prod code should call loadAppointmentReasons().
const memoizedLoadApptReasonsExportedForTesting = memoizee__WEBPACK_IMPORTED_MODULE_0___default()(async function() {
    let practiceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants_practiceIds__WEBPACK_IMPORTED_MODULE_2__/* .PracticeId.CARBON */ .I.CARBON, video = arguments.length > 1 ? arguments[1] : void 0, instant = arguments.length > 2 ? arguments[2] : void 0;
    const response = await (0,_utils_fetch_fetches__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()("/hib/practices/".concat(practiceId, "/apptReasons/v2?").concat(video ? "supportsVideoVisit=true" : "").concat(instant ? "supportsInstantVisit=true" : ""));
    return await response.json();
}, {
    maxAge: _constants_MsMap__WEBPACK_IMPORTED_MODULE_1__/* .MsMap.ONE_MINUTE */ .I.ONE_MINUTE * 20,
    promise: true
});


/***/ }),

/***/ 93291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69468);
/* harmony import */ var _hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40603);




const getTransitionStyles = (state, contentHeight)=>({
        entering: {},
        entered: {
            height: contentHeight
        },
        exiting: {
            height: contentHeight
        },
        exited: {},
        unmounted: {}
    })[state];
const Collapse = (param)=>{
    let { duration =150 , children , timeout =0 , disableAnimation , ...transitionProps } = param;
    const [transitionStatus, setTransitionStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const state = (0,_hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_2__/* .useDisclosure */ .q)();
    const transitionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const styleRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // This effect triggers the style change to `auto` after children enter.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        switch(transitionStatus){
            case "entered":
                {
                    setTimeout(state.open, duration);
                    break;
                }
            case "exiting":
                {
                    state.close();
                    break;
                }
        }
    }, [
        duration,
        state,
        transitionStatus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        nodeRef: transitionRef,
        timeout: timeout,
        ...transitionProps,
        children: (transitionStatus)=>{
            // Update state, but on next tick so that we don't update state while rendering
            setTimeout(()=>setTransitionStatus(transitionStatus), 0);
            const wrapperHeight = state.isOpen ? "auto" : innerRef.current ? innerRef.current.clientHeight : 0;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: styleRef,
                style: {
                    transition: "height ".concat(disableAnimation ? 0 : duration, "ms ease-in-out"),
                    overflow: "hidden",
                    height: 0,
                    width: "100%",
                    ...getTransitionStyles(transitionStatus, wrapperHeight)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: innerRef,
                    children: children
                })
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Collapse);


/***/ }),

/***/ 12267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ PhoneNumber; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);



const PhoneNumber = (param)=>{
    let { phoneNumber , onClick  } = param;
    const { t  } = (0,_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "flex justify-center font-ttm pt-4 pb-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mr-2",
                children: t("Or call to book")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                onClick: onClick,
                href: "tel:".concat(phoneNumber),
                className: "underline text-darkerBlue hover:text-darkerBlue ",
                children: phoneNumber
            })
        ]
    });
};


/***/ }),

/***/ 25561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ CareEntryRowVariant; },
  "Z": function() { return /* binding */ v5_CareEntryRow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/Locations/events.ts
var events = __webpack_require__(5816);
// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
// EXTERNAL MODULE: ./src/hooks/useQueryController.ts + 1 modules
var useQueryController = __webpack_require__(75290);
// EXTERNAL MODULE: ./src/hooks/useReadableSlotTime.ts + 1 modules
var useReadableSlotTime = __webpack_require__(8764);
// EXTERNAL MODULE: ./src/page-containers/booking/utils/bookingQuery.ts
var bookingQuery = __webpack_require__(28954);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/v5/Locations/usePairLocsWithSlots.ts
var usePairLocsWithSlots = __webpack_require__(61802);
// EXTERNAL MODULE: ./src/hooks/useSoonestVirtualSlot.ts
var useSoonestVirtualSlot = __webpack_require__(77230);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./src/utils/filterLocationsBySpecialtyId.ts
var filterLocationsBySpecialtyId = __webpack_require__(83821);
// EXTERNAL MODULE: ./src/utils/locationsByRegion.ts
var locationsByRegion = __webpack_require__(10241);
// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
;// CONCATENATED MODULE: ./src/queries/useSoonestSlotByReasonSlug.ts










const isReasonOnlyVirtual = (practiceApptReason)=>practiceApptReason && practiceApptReason.supportsVideoVisit.compact().length === practiceApptReason.supportsVideoVisit.length;
const fetchSoonestSlotByReasonSlug = (apptReason, locations, selectedRegion)=>isReasonOnlyVirtual(apptReason) ? (0,useSoonestVirtualSlot/* getSoonestVirtualSlot */.P8)(apptReason.specialtyIds, (0,stateUtils/* getStateCodeFromRegionSlug */.GZ)(selectedRegion)) : (0,usePairLocsWithSlots/* maybePairLocsWithSlots */.yr)(locations, apptReason).then(usePairLocsWithSlots/* reduceLocSlotPairsToSoonestSlot */.kE);
const reduceApptSlotsToSoonest = (apptSlots)=>{
    return apptSlots.reduce((acc, next)=>{
        const isNextValid = Number.isInteger(next === null || next === void 0 ? void 0 : next.time);
        const isFirstValid = acc === null;
        const nextIsSooner = (next === null || next === void 0 ? void 0 : next.time) < (acc === null || acc === void 0 ? void 0 : acc.time);
        return isNextValid && (isFirstValid || nextIsSooner) ? next : acc;
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'ApptSlot'.
    }, null);
};
const useSoonestSlotByReasonSlugsQuery = function(slugs, selectedLocation) {
    let skip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const storeLocations = (0,store/* useTypedSelector */.ix)((state)=>state.config.locations);
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const fn = (0,react.useCallback)(()=>slugs.map((slug)=>(0,api/* fetchReasonBySlug */.f_)(slug).then((apptReason)=>{
                const locationsToCheck = selectedLocation ? [
                    selectedLocation
                ] : storeLocations.filter((0,locationsByRegion/* regionFilter */.v)(selectedRegion)).filter((0,filterLocationsBySpecialtyId/* doesLocationHaveASpecialtyId */.e)(apptReason.specialtyIds)).slice(0, 3);
                return fetchSoonestSlotByReasonSlug(apptReason, locationsToCheck, selectedRegion);
            })).sequence()// @ts-expect-error TS2345: Argument of type '(apptSlots: ApptSlot[]) => ApptSlot' is not assignable to parameter of type '(value: (ApptSlot | null)[]) => ApptSlot | PromiseLike<ApptSlot>'.
        .then(reduceApptSlotsToSoonest), [
        selectedLocation,
        selectedRegion,
        slugs,
        storeLocations
    ]);
    // @ts-expect-error TS2322: Type 'QueryState<ApptSlot | null>' is not assignable to type 'QueryState<ApptSlot>'.
    return (0,useQueryController/* useQueryController */.co)({
        fn,
        cacheKey: JSON.stringify({
            slugs,
            selectedLocation: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.slug,
            selectedRegion
        }),
        skip,
        ifRejectedValue: null,
        initialValue: null
    });
};

// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/getAllRelatedCares.ts
var getAllRelatedCares = __webpack_require__(88103);
// EXTERNAL MODULE: ./src/components/v5/Glimmer.tsx
var Glimmer = __webpack_require__(88177);
// EXTERNAL MODULE: ./src/components/v5/LinkOrButton.tsx
var LinkOrButton = __webpack_require__(73439);
;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/Interaction.tsx



const Interaction = (param)=>/*#__PURE__*/ {
    let { children , href , onClick , isBold =false , disabled =false , cypressKey  } = param;
    return (0,jsx_runtime.jsx)(LinkOrButton/* default */.Z, {
        "data-cy": cypressKey,
        href: disabled ? null : href,
        onClick: onClick,
        disabled: disabled,
        className: "outline-none bg-transparent w-full border border-solid border-transparent hover:border-gray200 transition-colors inline-block text-left focus-bsDarkBlue3-hug px-0 py-0 hover-font-ib rounded-lg ".concat(isBold ? "font-ib" : "font-ir", " ").concat(disabled ? "cursor-default" : "cursor-pointer", "\n    "),
        children: children
    });
};
/* harmony default export */ var CareEntryRow_Interaction = (/*#__PURE__*/react.memo(Interaction));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/LeftIcon.tsx


const LeftIcon = (param)=>/*#__PURE__*/ {
    let { icon , className ="" , size ="md"  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: "p-4 flex items-center justify-center flex-shrink-0 ".concat(size === "lg" ? "fs30" : size === "md" ? "fs26" : "fs24", " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "darkBlue cIcon-".concat(icon),
            "aria-hidden": true
        })
    });
};
/* harmony default export */ var CareEntryRow_LeftIcon = (/*#__PURE__*/react.memo(LeftIcon));

// EXTERNAL MODULE: ./node_modules/react-string-replace/index.js
var react_string_replace = __webpack_require__(19330);
var react_string_replace_default = /*#__PURE__*/__webpack_require__.n(react_string_replace);
;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/Line.tsx



const Line = (param)=>/*#__PURE__*/ {
    let { keyPrefix , text , query , className =""  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: "gray800 text-basic leading-none empty:hidden ".concat(query ? "font-im" : "font-isb", " ").concat(className),
        children: react_string_replace_default()(text, query, (match, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("mark", {
                className: "bg-transparent font-isb",
                children: match
            }, "".concat(keyPrefix, "-").concat(match, "-").concat(i)))
    });
};
/* harmony default export */ var CareEntryRow_Line = (/*#__PURE__*/react.memo(Line));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/RightIcon.tsx


const RightIcon = (param)=>/*#__PURE__*/ {
    let { className =""  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "df fdc aife minw2 mr1 gray600 fs20 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "cIcon-arrRight",
            "aria-hidden": true
        })
    });
};
/* harmony default export */ var CareEntryRow_RightIcon = (/*#__PURE__*/react.memo(RightIcon));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/SlotTime.tsx



const SlotTime = (param)=>{
    let { readableSlotTime , isLoading =false , className =""  } = param;
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
        height: 20,
        width: 100
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
        "data-cy": "slot-time",
        className: "darkGreen font-isb text-sm ls-25 empty:hidden ".concat(className),
        children: readableSlotTime
    });
};
/* harmony default export */ var CareEntryRow_SlotTime = (/*#__PURE__*/react.memo(SlotTime));

// EXTERNAL MODULE: ./src/components/v5/Composition/CardRow.tsx
var CardRow = __webpack_require__(91706);
// EXTERNAL MODULE: ./src/components/v5/Composition/Tag.tsx
var Tag = __webpack_require__(58410);
;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/Tags.tsx





const Tags = (param)=>/*#__PURE__*/ {
    let { turnaround , price , isSlotLoading , readableSlotTime  } = param;
    return (0,jsx_runtime.jsxs)(CardRow/* CardRow */.l, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                children: turnaround
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                className: "font-isb text-sm empty:hidden",
                children: price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_SlotTime, {
                readableSlotTime: readableSlotTime,
                isLoading: isSlotLoading
            })
        ]
    });
};
/* harmony default export */ var CareEntryRow_Tags = (/*#__PURE__*/react.memo(Tags));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/Presentation.tsx










const styles = {
    icon: {
        borderRadius: "50%",
        flexShrink: 0
    }
};
const Sm = /*#__PURE__*/ react.memo((param)=>/*#__PURE__*/ {
    let { icon , line1 , readableSlotTime , query , isSlotLoading , isLoading =false  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "flex aic justify-start py-3",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-2 flex justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 24,
                        width: 24,
                        style: styles.icon,
                        offset: Glimmer/* GlimmerOffset.XXS */.u.XXS
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-flow-row gap-1 pr-4 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 30,
                        width: "100%"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_LeftIcon, {
                    icon: icon,
                    className: "px-2 py-0",
                    size: "sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ml-1 flex justify-start flex-wrap w-full first:mr-2 py-1 aic flex-col items-start sm:flex-row sm:items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Line, {
                            keyPrefix: "name",
                            className: "mr-2",
                            text: line1,
                            query: query
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_SlotTime, {
                            className: "fs14",
                            readableSlotTime: readableSlotTime,
                            isLoading: isSlotLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_RightIcon, {
                    className: "minw2-f mr2-f"
                })
            ]
        })
    });
});
const Md = /*#__PURE__*/ react.memo((param)=>/*#__PURE__*/ {
    let { query , icon , line1 , price , turnaround , isSlotLoading , readableSlotTime , isLoading =false  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "flex justify-between items-center py-2",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-2 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 37,
                        width: 37,
                        style: styles.icon,
                        offset: Glimmer/* GlimmerOffset.XXS */.u.XXS
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-flow-row gap-1 w-full pr-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                            height: 30,
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                            height: 18,
                            width: 200
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_LeftIcon, {
                    icon: icon,
                    size: "md",
                    className: "px-4 py-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex flex-col justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Line, {
                            keyPrefix: "line1",
                            className: "mb-1",
                            text: line1,
                            query: query
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Tags, {
                            turnaround: turnaround,
                            price: price,
                            isSlotLoading: isSlotLoading,
                            readableSlotTime: readableSlotTime
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_RightIcon, {})
            ]
        })
    });
});
const Lg = /*#__PURE__*/ react.memo((param)=>/*#__PURE__*/ {
    let { query , icon , line1 , line2 , price , turnaround , isSlotLoading , readableSlotTime , isLoading =false  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "flex justify-between items-center py-4",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-2 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 40,
                        width: 40,
                        style: styles.icon,
                        offset: Glimmer/* GlimmerOffset.XXS */.u.XXS
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-flow-row gap-1 pr-4 w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                            height: 30,
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                            height: 24,
                            width: "50%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                            height: 16,
                            width: 100
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_LeftIcon, {
                    icon: icon,
                    size: "lg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex flex-col justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Line, {
                            keyPrefix: "line1",
                            className: "mb-2",
                            text: line1,
                            query: query
                        }),
                        line2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Line, {
                            keyPrefix: "line2",
                            className: "font-ir-f mb-1 !text-sm",
                            text: line2,
                            query: query
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_Tags, {
                            turnaround: turnaround,
                            price: price,
                            isSlotLoading: isSlotLoading,
                            readableSlotTime: readableSlotTime
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow_RightIcon, {})
            ]
        })
    });
});
Sm.displayName = "SmCareEntryListRow";
Md.displayName = "MdCareEntryListRow";
Lg.displayName = "LgCareEntryListRow";
const CareEntryRow = (param)=>/*#__PURE__*/ {
    let { query , href , onClick , icon , line1 , line2 , price , turnaround , isSlotLoading , readableSlotTime , variant , isLoading =false , cypressKey  } = param;
    return (0,jsx_runtime.jsx)(CareEntryRow_Interaction, {
        href: href,
        onClick: onClick,
        isBold: Boolean(query),
        disabled: isLoading,
        cypressKey: cypressKey,
        children: variant === CareEntryRowVariant.LG ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Lg, {
            query: query,
            icon: icon,
            line1: line1,
            line2: line2,
            price: price,
            turnaround: turnaround,
            readableSlotTime: readableSlotTime,
            isSlotLoading: isSlotLoading,
            isLoading: isLoading
        }) : variant === CareEntryRowVariant.MD ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Md, {
            query: query,
            icon: icon,
            line1: line1,
            price: price,
            turnaround: turnaround,
            readableSlotTime: readableSlotTime,
            isSlotLoading: isSlotLoading,
            isLoading: isLoading
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Sm, {
            query: query,
            icon: icon,
            line1: line1,
            readableSlotTime: readableSlotTime,
            isSlotLoading: isSlotLoading,
            isLoading: isLoading
        })
    });
};
CareEntryRow.displayName = "CareEntryRow";
/* harmony default export */ var Presentation = (/*#__PURE__*/react.memo(CareEntryRow));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/Control.tsx















const CareEntryRowControl = (param)=>{
    let { result , selectedLocation , query , rank , variant =CareEntryRowVariant.MD , isLoading =false , reportClickEvent , maybeToggleDialog , maybeAddCareToTopicStack , cypressKey , canSendApptStartEvent =false , viewId  } = param;
    var _soonestSlotQuery_data;
    const router = (0,next_router.useRouter)();
    const isTopic = !result.appointment_reason;
    const { name , brief_description , slug , turnaround , price , override_url , icon ="defaultReasonIcon"  } = result;
    const { locationsSorted  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED */.T.GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED);
    const slugsToCheck = (0,react.useMemo)(()=>{
        var _result_cares;
        return isTopic ? ((_result_cares = result.cares) === null || _result_cares === void 0 ? void 0 : _result_cares.map((care)=>care.slug).slice(0, 4)) || [] : [
            result.slug
        ];
    }, [
        isTopic,
        result.cares,
        result.slug
    ]);
    const soonestSlotQuery = useSoonestSlotByReasonSlugsQuery(slugsToCheck, selectedLocation, !locationsSorted || !GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED);
    const soonestSlotTime = (_soonestSlotQuery_data = soonestSlotQuery.data) === null || _soonestSlotQuery_data === void 0 ? void 0 : _soonestSlotQuery_data.time;
    const readableSlotTime = (0,useReadableSlotTime/* useReadableSlotTime */.H5)(soonestSlotTime, {
        withNext: true
    });
    const maybeAddSelfToStack = maybeAddCareToTopicStack === null || maybeAddCareToTopicStack === void 0 ? void 0 : maybeAddCareToTopicStack(result.slug, Boolean((0,getAllRelatedCares/* getAllRelatedCares */.M)(result).length));
    const onClick = (0,react.useCallback)(async ()=>{
        const shouldStartBooking = !isTopic && selectedLocation && soonestSlotTime;
        if (maybeAddSelfToStack) {
            maybeAddSelfToStack(result);
            reportClickEvent === null || reportClickEvent === void 0 ? void 0 : reportClickEvent(result, soonestSlotQuery.data, rank, undefined, viewId);
        } else if (shouldStartBooking) {
            const { bookingLink , flowId , WEB_SCHEDULING_ENABLED  } = await (0,bookingQuery/* getSchedulingLink */.pq)({
                pathname: router.pathname,
                specialtyIds: soonestSlotQuery.data.specialtyIds,
                webSchedulingQuery: {
                    locationSlug: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.slug,
                    appointmentReasonSlug: result.slug,
                    originUrl: router.asPath,
                    initialCalendarTime: soonestSlotTime
                },
                patientAppSchedulingQuery: {
                    practiceId: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.practiceId,
                    specialtyId: soonestSlotQuery.data.specialtyIds,
                    apptReasonId: result.appointment_reason || undefined,
                    locationId: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.id,
                    preselectedState: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.address.state
                }
            });
            if (WEB_SCHEDULING_ENABLED && canSendApptStartEvent) {
                (0,events/* sendInitiateWebSchedulingEvent */.q)(flowId);
            }
            reportClickEvent === null || reportClickEvent === void 0 ? void 0 : reportClickEvent(result, soonestSlotQuery.data, rank, flowId, viewId);
            router.push(bookingLink);
        } else {
            reportClickEvent === null || reportClickEvent === void 0 ? void 0 : reportClickEvent(result, soonestSlotQuery.data, rank, undefined, viewId);
            const carePageHref = {
                pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                query: {
                    slug
                }
            };
            const href = override_url || result.href || carePageHref;
            if (href) {
                router.push(href);
            }
        }
        maybeToggleDialog === null || maybeToggleDialog === void 0 ? void 0 : maybeToggleDialog(!maybeAddSelfToStack);
    }, [
        maybeAddSelfToStack,
        maybeToggleDialog,
        result,
        reportClickEvent,
        soonestSlotQuery.data,
        rank,
        viewId,
        selectedLocation,
        soonestSlotTime,
        isTopic,
        slug,
        override_url,
        canSendApptStartEvent,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Presentation, {
        cypressKey: cypressKey,
        query: query,
        onClick: onClick,
        icon: icon,
        line1: name,
        line2: brief_description || undefined,
        price: price,
        turnaround: turnaround,
        isSlotLoading: soonestSlotQuery.status === useQueryController/* QueryStatus.LOADING */.oZ.LOADING,
        readableSlotTime: readableSlotTime || undefined,
        variant: variant,
        isLoading: isLoading
    });
};
CareEntryRowControl.displayName = "CareEntryRowControl";
/* harmony default export */ var Control = (/*#__PURE__*/react.memo(CareEntryRowControl));

;// CONCATENATED MODULE: ./src/components/v5/CareEntryRow/index.tsx

var CareEntryRowVariant;
(function(CareEntryRowVariant) {
    CareEntryRowVariant["SM"] = "sm";
    CareEntryRowVariant["MD"] = "md";
    CareEntryRowVariant["LG"] = "lg";
})(CareEntryRowVariant || (CareEntryRowVariant = {}));
/* harmony default export */ var v5_CareEntryRow = (Control);


/***/ }),

/***/ 99902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const Icon = (param)=>/*#__PURE__*/ {
    let { icon , className =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "cIcon-".concat(icon, " ").concat(className),
        "aria-hidden": true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Icon));


/***/ }),

/***/ 73439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);



const LinkOrButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((param)=>{
    let { href , children , ...props } = param;
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        })
    }) : // @ts-expect-error TS2322: Type '{ children: ReactI18NextChild | Iterable<ReactI18NextChild>; about?: string | undefined; download?: any; id?: string | undefined; ... 268 more ...; value?: string | ... 2 more ... | undefined; } | { ...; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        ...props,
        children: children
    });
});
LinkOrButton.displayName = "LinkOrButton";
/* harmony default export */ __webpack_exports__["Z"] = (LinkOrButton);


/***/ }),

/***/ 5726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Location_ImageCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(80130);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
;// CONCATENATED MODULE: ./src/utils/getGoogleMapsStaticImgSrc.ts



const getGoogleMapsStaticImgSrc = (coordinate, googleApiKey)=>{
    const mapStyles = [
        // `feature:all|visibility:simplified`,
        "feature:poi|visibility:off",
        "feature:transit|visibility:off",
        "feature:water|element:geometry|color:0x".concat(palette.darkerYellow.replace(/#/, "")),
        "feature:water|element:labels|visibility:off",
        "feature:road|color:0x".concat(palette.darkerYellow.replace(/#/, "")),
        "feature:road|element:geometry|weight:1",
        "feature:road|element:labels.text.stroke|color:0x".concat(palette.yellow.replace(/#/, ""), "|weight:8"),
        "feature:landscape|color:0x".concat(palette.yellow.replace(/#/, ""))
    ].map((rule)=>"style=".concat(rule)).join("&");
    const mapDimensions = {
        x: 150,
        y: 150
    };
    return dist_default().stringifyUrl({
        url: "https://maps.googleapis.com/maps/api/staticmap",
        query: {
            key: googleApiKey,
            center: "".concat(coordinate.x, ",").concat(coordinate.y),
            zoom: 15,
            size: "".concat(mapDimensions.x, "x").concat(mapDimensions.y),
            scale: 2,
            format: "jpg",
            markers: "anchor:32,64|icon:".concat(_constants/* googleStaticMapMarker */.Pp, "|").concat(coordinate.x, ",").concat(coordinate.y, "|"),
            mapStyles
        }
    }, {
        encode: false
    });
};

;// CONCATENATED MODULE: ./src/utils/modifyViewportDimension.ts
const modifyViewportDimension = (vpDimension, // @ts-expect-error TS7051: Parameter has a name but no type. Did you mean 'arg0: number'?
modifier)=>{
    const axis = vpDimension.replace(/[0-9]/gi, "");
    const originalVpDimension = parseInt(vpDimension.replace("vw", ""));
    const newVpDimension = modifier(originalVpDimension);
    return "".concat(newVpDimension).concat(axis);
};

// EXTERNAL MODULE: ./src/components/animations/Fade.tsx
var Fade = __webpack_require__(25);
// EXTERNAL MODULE: ./src/components/v5/Glimmer.tsx
var Glimmer = __webpack_require__(88177);
;// CONCATENATED MODULE: ./src/components/v5/Location/ImageCarousel.tsx









const isCoordinate = (image)=>typeof image === "object" && image && "x" in image && "y" in image;
const ImageCarousel = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { images , imageWindowWidth ="100%" , imageScaleFactor =1 , onFirstImageScroll , loading =false , label  } = param;
    var _imageContainerRef_current;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { config: { googleApiKey , isMobile  } , isKeyboardUser  } = (0,store/* useTypedSelector */.ix)((state)=>state);
    const imageContainerRef = (0,react.useRef)(null);
    const [scrollEventSent, setScrollEventSent] = (0,react.useState)(false);
    const [isScrollEnd, setIsScrollEnd] = (0,react.useState)("left");
    const [rightButtonPosition, setRightButtonPosition] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const imageContainer = imageContainerRef && imageContainerRef.current;
        if (imageContainer) {
            setRightButtonPosition(imageContainer.clientWidth - 80);
        }
    }, [
        imageContainerRef === null || imageContainerRef === void 0 ? void 0 : (_imageContainerRef_current = imageContainerRef.current) === null || _imageContainerRef_current === void 0 ? void 0 : _imageContainerRef_current.clientWidth
    ]);
    const sendLocationImageScrollEvent = ()=>{
        if (!scrollEventSent && onFirstImageScroll) {
            setScrollEventSent(true);
            onFirstImageScroll();
        }
    };
    const isScrollEndListener = ()=>{
        const imageContainer = imageContainerRef && imageContainerRef.current;
        if (imageContainer) {
            const maxScrollLeft = imageContainer.scrollWidth - imageContainer.clientWidth;
            switch(maxScrollLeft - imageContainer.scrollLeft){
                case 0:
                    setIsScrollEnd("right");
                    break;
                case maxScrollLeft:
                    setIsScrollEnd("left");
                    break;
                default:
                    setIsScrollEnd(null);
            }
        }
    };
    const imageWidth = modifyViewportDimension("42vw", (x)=>x * imageScaleFactor);
    const imageHeight = modifyViewportDimension("27vw", (x)=>x * imageScaleFactor);
    (0,react.useEffect)(()=>{
        const imageContainer = imageContainerRef && imageContainerRef.current;
        if (scrollEventSent) {
            // @ts-expect-error TS2531: Object is possibly 'null'.
            imageContainer.removeEventListener("scroll", sendLocationImageScrollEvent);
        } else if (imageContainer) {
            imageContainer.addEventListener("scroll", sendLocationImageScrollEvent);
        }
        // @ts-expect-error TS2531: Object is possibly 'null'.
        imageContainer.addEventListener("scroll", isScrollEndListener);
        return ()=>{
            // @ts-expect-error TS2531: Object is possibly 'null'.
            imageContainer.removeEventListener("scroll", sendLocationImageScrollEvent);
            // @ts-expect-error TS2531: Object is possibly 'null'.
            imageContainer.removeEventListener("scroll", isScrollEndListener);
        };
    }, [
        imageContainerRef,
        scrollEventSent
    ]);
    const getImgSrc = (image)=>typeof image === "string" ? image : "src" in image ? image.src : getGoogleMapsStaticImgSrc(image, googleApiKey);
    const locationImages = images.map((img, i)=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
            className: "mr2 br1 pos-r",
            style: {
                minWidth: isCoordinate(img) ? imageHeight : imageWidth,
                minHeight: imageHeight
            },
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                offset: Glimmer/* GlimmerOffset.SM */.u.SM
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                className: "br1 wa obfc",
                src: getImgSrc(img),
                layout: "fill",
                priority: i < 3,
                // @ts-expect-error TS2339: Property 'alt' does not exist on type 'string | Coordinate | SrcAndAlt'.
                alt: (img === null || img === void 0 ? void 0 : img.alt) || ""
            })
        }, "img-carousel-".concat(i));
    });
    const imagesContainerWidth = modifyViewportDimension(imageWidth, (x)=>(x * images.length + 35) * imageScaleFactor);
    const [leftIsFocused, setLeftIsFocused] = (0,react.useState)(false);
    const [rightIsFocused, setRightIsFocused] = (0,react.useState)(false);
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    // Always show for keyboard users mobile or desktop, otherwise show if images are hovered or buttons are focused and not mobile
    const showLeftButton = isKeyboardUser || (isHovered || leftIsFocused) && !isMobile;
    const showRightButton = isKeyboardUser || (isHovered || rightIsFocused) && !isMobile;
    const getImageRenderedWidth = ()=>window.innerWidth * parseInt(imageWidth.replace("vw", "")) / 100 + 5;
    const scrollRight = ()=>{
        sendLocationImageScrollEvent();
        // @ts-expect-error TS2531: Object is possibly 'null'.
        imageContainerRef.current.scrollLeft += getImageRenderedWidth();
    };
    const scrollLeft = ()=>{
        // @ts-expect-error TS2531: Object is possibly 'null'.
        imageContainerRef.current.scrollLeft -= getImageRenderedWidth();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-roledescription": "carousel",
        "aria-label": label,
        className: "mt2 mb0 hide-scroll-bars pos-r",
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: imageContainerRef,
                className: "ovf-x-a",
                style: {
                    scrollBehavior: "smooth",
                    width: imageWindowWidth
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        id: "carousel",
                        className: "df pl40",
                        style: {
                            scrollBehavior: "smooth",
                            marginLeft: -160,
                            width: imagesContainerWidth,
                            maxWidth: "100vw"
                        },
                        children: [
                            locationImages,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "minw1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: showLeftButton && isScrollEnd !== "left",
                        unmountOnExit: true,
                        timeout: 150,
                        appear: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-controls": "carousel",
                            onClick: scrollLeft,
                            style: {
                                left: 5
                            },
                            className: "pos-a top0 bottom0 ma br50 h10 w10 df aic jcc pl1 brdn otn cp",
                            onFocus: ()=>setLeftIsFocused(true),
                            onBlur: ()=>setLeftIsFocused(false),
                            "aria-label": i18n.t("Scroll left"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-dropdown-arrow-up rotate270 gray800 fs18",
                                "aria-hidden": true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: showRightButton && isScrollEnd !== "right",
                        unmountOnExit: true,
                        timeout: 150,
                        appear: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-controls": "carousel",
                            onClick: scrollRight,
                            className: "pos-a top0 bottom0 ma br50 h10 w10 df aic jcc pr1 brdn otn cp",
                            onFocus: ()=>setRightIsFocused(true),
                            onBlur: ()=>setRightIsFocused(false),
                            "aria-label": i18n.t("Scroll right"),
                            style: {
                                left: rightButtonPosition
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-dropdown-arrow-up rotate90 gray800 fs18",
                                "aria-hidden": true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: "widget"
            })
        ]
    });
});
ImageCarousel.displayName = "ImageCarousel";
/* harmony default export */ var Location_ImageCarousel = (ImageCarousel);


/***/ }),

/***/ 5816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ sendClinicListRowClickEvent; },
/* harmony export */   "q": function() { return /* binding */ sendInitiateWebSchedulingEvent; }
/* harmony export */ });
/* harmony import */ var _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(557);
/* harmony import */ var _utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57659);
/* harmony import */ var _utils_browser_storage_trafficId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13527);



const sendClinicListRowClickEvent = (value, viewId, locationId, rank, soonestSlotTime, milesAway, flowId)=>(0,_utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_1__/* .queueEvent */ .x$)({
        typeId: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .EventType.AppointmentBookingReasonWidgetClicked */ .tw.AppointmentBookingReasonWidgetClicked,
        extraData: {
            category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .CustomCategory.AppointmentScheduling */ .mg.AppointmentScheduling,
            value,
            locationId,
            soonestSlotTime,
            viewId,
            milesAway,
            flowId,
            rank
        }
    });
const sendInitiateWebSchedulingEvent = (flowId)=>(0,_utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_1__/* .queueEvent */ .x$)({
        category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .EventCategory.Custom */ .Jk.Custom,
        typeId: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .EventType.AppointmentBookingStarted */ .tw.AppointmentBookingStarted,
        extraData: {
            category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .CustomCategory.AppointmentScheduling */ .mg.AppointmentScheduling,
            flowId,
            trafficId: (0,_utils_browser_storage_trafficId__WEBPACK_IMPORTED_MODULE_2__/* .getTrafficId */ ._Z)()
        }
    });


/***/ }),

/***/ 76096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ useListBoundaryController; }
});

// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(37453);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/components/v5/Reason/ShowMoreButton.tsx
var ShowMoreButton = __webpack_require__(41519);
;// CONCATENATED MODULE: ./src/page-containers/get-care/components/ListController.tsx




const ListController = (param)=>{
    let { start , stop , total , isMaxed , handleShowMoreClick  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df aic fw pos-r zIndex2 pb2",
        style: {
            marginTop: -15
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-ir mr3 fs14",
                children: i18n.t("{{firstNumber}} - {{secondNumber}} of {{total}}", {
                    firstNumber: start + 1,
                    secondNumber: stop,
                    total
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButton/* default */.Z, {
                onClick: handleShowMoreClick,
                text: isMaxed ? i18n.t("Show less") : i18n.t("Show more"),
                flipIcon: isMaxed
            })
        ]
    });
};
/* harmony default export */ var components_ListController = (ListController);

;// CONCATENATED MODULE: ./src/components/v5/Locations/useClinicListBoundaryController.ts



const memoizedSlice = memoizee_default()((list, start, stop)=>list.slice(start, stop));
/**
 * This utility hook gets the bounding list indexes for the care-discovery list
 * components in order to control how many results are being rendered. It also
 * provides control functions for updating the boundaries.s
 * @param minBindingThreshold If the list is shorter than this threshold (which defaults)
 * to 7, then `bindList` will not trim the list.
 */ const useListBoundaryController = function(listLength, initialStop) {
    let minBindingThreshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 7;
    const getInitialBoundaries = (0,react.useCallback)(()=>[
            0,
            initialStop
        ], [
        initialStop
    ]);
    const [[start, stop], setRenderBoundaries] = (0,react.useState)(getInitialBoundaries());
    (0,react.useEffect)(()=>{
        setRenderBoundaries(getInitialBoundaries());
    }, [
        listLength,
        initialStop,
        minBindingThreshold,
        getInitialBoundaries
    ]);
    const showMore = (0,react.useCallback)(()=>{
        setRenderBoundaries([
            start,
            Math.min(stop + 10, listLength)
        ]);
    }, [
        listLength,
        start,
        stop
    ]);
    const reset = (0,react.useCallback)(()=>{
        setRenderBoundaries(getInitialBoundaries());
    }, [
        getInitialBoundaries
    ]);
    const bindList = (0,react.useCallback)((list)=>listLength >= minBindingThreshold ? memoizedSlice(list, start, stop) : list, [
        listLength,
        minBindingThreshold,
        start,
        stop
    ]);
    const isMaxed = stop >= listLength;
    const Controller = (0,react.useCallback)((param)=>{
        let { onReset  } = param;
        return react.createElement(components_ListController, {
            start,
            stop,
            isMaxed,
            total: listLength,
            handleShowMoreClick: ()=>{
                if (isMaxed) {
                    reset();
                    onReset();
                } else {
                    showMore();
                }
            }
        });
    }, [
        isMaxed,
        listLength,
        reset,
        showMore,
        start,
        stop
    ]);
    return {
        start,
        stop,
        isMaxed,
        showMore,
        bindList,
        reset,
        ListController: react.memo(Controller)
    };
};


/***/ }),

/***/ 61802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ usePairLocsWithSlotsQuery; },
/* harmony export */   "kE": function() { return /* binding */ reduceLocSlotPairsToSoonestSlot; },
/* harmony export */   "yr": function() { return /* binding */ maybePairLocsWithSlots; }
/* harmony export */ });
/* unused harmony exports moveLocsWithoutAvailabilityToEnd, reducePreferedLocSlotPairs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93209);
/* harmony import */ var _hooks_useQueryController__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75290);
/* harmony import */ var _utils_fetchCachedSlot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32570);
/* harmony import */ var _utils_noOp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47597);
/* harmony import */ var _utils_promise_tee__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35721);






const specialtyPreferenceOrder = [
    ...src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .covidTestingSpecialtyIds */ .jj,
    src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .SpecialtyId.URGENT_CARE */ .mg.URGENT_CARE,
    src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .SpecialtyId.PRIMARY_CARE */ .mg.PRIMARY_CARE
];
const getInClinicSpecialtyIds = (ids)=>ids.filter((specialtyId)=>!src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .virtualSpecialtyIds.includes */ .A.includes(specialtyId));
const moveLocsWithoutAvailabilityToEnd = (locSlotPairs)=>{
    const divided = locSlotPairs.reduce((acc, next)=>{
        var _next_soonestSlot;
        // @ts-expect-error TS2345: Argument of type 'LocSlotPair' is not assignable to parameter of type 'never'.
        acc[((_next_soonestSlot = next.soonestSlot) === null || _next_soonestSlot === void 0 ? void 0 : _next_soonestSlot.time) ? "with" : "without"].push(next);
        return acc;
    }, {
        with: [],
        without: []
    });
    return [
        ...divided.with,
        ...divided.without
    ];
};
const reducePreferedLocSlotPairs = (locSlotPairs)=>{
    // @ts-expect-error TS2322: Type 'string | LocSlotPair | null' is not assignable to type 'LocSlotPair'.
    return specialtyPreferenceOrder.reduce((maybeFoundLocSlotPair, preferredSpecialtyId)=>maybeFoundLocSlotPair || // if one has already been found, use that one. Otherwise...
        locSlotPairs.find((locSlotPair)=>locSlotPair.specialtyId === preferredSpecialtyId), // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'LocSlotPair'.
    null) || locSlotPairs.sortBy((locSlotPair)=>{
        var _locSlotPair_soonestSlot;
        return (_locSlotPair_soonestSlot = locSlotPair.soonestSlot) === null || _locSlotPair_soonestSlot === void 0 ? void 0 : _locSlotPair_soonestSlot.time;
    })[0] || null;
}; // If none were found in specialty preference order, grab the one with the soonest slot.
const fetchAndFormatSlots = function(location, specialtyId, reasonId) {
    let slotParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return (0,_utils_fetchCachedSlot__WEBPACK_IMPORTED_MODULE_3__/* .fetchCachedSlots */ .F)({
        locationId: location.id,
        specialtyId,
        reasonId,
        ...slotParams
    }).then((slots)=>{
        return {
            location,
            specialtyId,
            soonestSlot: (slots === null || slots === void 0 ? void 0 : slots[0]) || null,
            slots
        };
    });
};
const generateLocSlotPairs = (param)=>{
    let { locations , apptReason , slotParams  } = param;
    const reasonSpecialtyIdsToCheck = getInClinicSpecialtyIds(apptReason.specialtyIds);
    return locations.map((location)=>reasonSpecialtyIdsToCheck.filter((id)=>location.specialtyIds.includes(id)).map((specialtyId)=>fetchAndFormatSlots(location, specialtyId, apptReason.id, slotParams)).sequence().then(reducePreferedLocSlotPairs)).sequence().then(moveLocsWithoutAvailabilityToEnd);
};
const generateBlankLocSlotPairs = (param)=>{
    let { locations , apptReason  } = param;
    const getFirstPreferredSpecialty = (location)=>{
        return specialtyPreferenceOrder.find((id)=>{
            return location.specialtyIds.includes(id) && (apptReason === null || apptReason === void 0 ? void 0 : apptReason.specialtyIds.includes(id));
        });
    };
    return locations.map((location)=>{
        const specialtyId = getFirstPreferredSpecialty(location);
        return {
            location,
            soonestSlot: null,
            specialtyId,
            slots: []
        };
    });
};
const reduceLocSlotPairsToSoonestSlot = (locSlotPairs)=>{
    return locSlotPairs.reduce((acc, locSlotPair)=>{
        var _locSlotPair_soonestSlot, _locSlotPair_soonestSlot1;
        const isNextValid = Number.isInteger(locSlotPair === null || locSlotPair === void 0 ? void 0 : (_locSlotPair_soonestSlot = locSlotPair.soonestSlot) === null || _locSlotPair_soonestSlot === void 0 ? void 0 : _locSlotPair_soonestSlot.time);
        const isFirstValid = acc === null;
        // @ts-expect-error TS2532, TS2532: Object is possibly 'undefined'.,  Object is possibly 'undefined'.
        const nextIsSooner = (locSlotPair === null || locSlotPair === void 0 ? void 0 : (_locSlotPair_soonestSlot1 = locSlotPair.soonestSlot) === null || _locSlotPair_soonestSlot1 === void 0 ? void 0 : _locSlotPair_soonestSlot1.time) < (acc === null || acc === void 0 ? void 0 : acc.time);
        return isNextValid && (isFirstValid || nextIsSooner) ? locSlotPair.soonestSlot : acc;
    }, null);
};
const maybePairLocsWithSlots = (locations, apptReason, slotParams)=>apptReason ? generateLocSlotPairs({
        locations,
        apptReason,
        slotParams
    }) : Promise.resolve(generateBlankLocSlotPairs({
        locations,
        apptReason
    }));
const usePairLocsWithSlotsQuery = (param)=>{
    let { locations , apptReason , reportClinicOptions =_utils_noOp__WEBPACK_IMPORTED_MODULE_4__/* .noOp */ .E , slotParams , skip  } = param;
    const defaultValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>[], []);
    const fn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>maybePairLocsWithSlots(locations, apptReason, slotParams).then((0,_utils_promise_tee__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(reportClinicOptions)), [
        apptReason,
        locations,
        reportClinicOptions,
        slotParams
    ]);
    return (0,_hooks_useQueryController__WEBPACK_IMPORTED_MODULE_2__/* .useQueryController */ .co)({
        fn,
        skip,
        initialValue: defaultValue,
        cacheKey: JSON.stringify({
            id: apptReason.id,
            slotParams,
            locations: locations.map((l)=>l.id)
        })
    });
};


/***/ }),

/***/ 57852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CareDiscoverySearch_CareDiscoverySearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/CareEntryRow/index.tsx + 9 modules
var CareEntryRow = __webpack_require__(25561);
// EXTERNAL MODULE: ./src/components/v5/components/Dialog/useDialog.tsx
var useDialog = __webpack_require__(93063);
// EXTERNAL MODULE: ./src/components/v5/Input/TextInput.tsx
var TextInput = __webpack_require__(85208);
// EXTERNAL MODULE: ./src/components/v5/Locations/useClinicListBoundaryController.ts + 1 modules
var useClinicListBoundaryController = __webpack_require__(76096);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/hooks/useCareEntryExtensions.ts
var useCareEntryExtensions = __webpack_require__(63871);
;// CONCATENATED MODULE: ./src/hooks/useHoveredIndexController.ts

const useHoveredIndexController = ()=>{
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const unsetHovered = (0,react.useCallback)(()=>setActiveIndex(null), [
        setActiveIndex
    ]);
    return (0,react.useMemo)(()=>({
            unsetHovered,
            setHovered: setActiveIndex,
            activeIndex
        }), [
        unsetHovered,
        activeIndex
    ]);
};

// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/components/animations/Collapse.tsx
var Collapse = __webpack_require__(93291);
// EXTERNAL MODULE: ./src/components/v5/CareDiscovery/PhoneNumber.tsx
var PhoneNumber = __webpack_require__(12267);
;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/ResultList.tsx









const border = "after:content-[''] after:h-[1px] after:w-[100%] after:flex after:transition-colors";
const borderStyleSwitch = (disabled)=>disabled ? "".concat(border, " after:bg-transparent") : "".concat(border, " after:bg-gray100");
const getBorder = (index, hoveredIndex, totalItemCount, disable)=>borderStyleSwitch(disable || index === hoveredIndex || index === (hoveredIndex || -100) - 1 || index === totalItemCount - 1);
const getRowKey = (prefix, slug)=>"".concat(prefix, "-").concat(slug);
const blankResult = {
    name: "",
    slug: ""
};
const ResultList = (param)=>{
    let { viewId , keyPrefix , careEntries , transitionSpeed , selectedLocation , highlightQuery , rowVariant , hide , hideBorders =false , hideListController =false , className ="" , loadingRowCount =0 , shouldExpandIfTopic =false , disableAnimation =false , phoneNumber , reportClickEvent , maybeToggleDialog , maybeAddCareToTopicStack , canSendApptStartEvent =false  } = param;
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const shouldBindList = isSm && !hideListController;
    const firstLocRef = (0,react.useRef)(null);
    const extendedCareEntries = (0,useCareEntryExtensions/* useExtendCareEntries */.H)(careEntries);
    const { ListController , bindList  } = (0,useClinicListBoundaryController/* useListBoundaryController */.m)(extendedCareEntries.length, 4);
    const boundList = shouldBindList ? bindList(extendedCareEntries) : extendedCareEntries;
    const showListController = shouldBindList && extendedCareEntries.length > 6;
    const onListReset = (0,react.useCallback)(()=>{
        if (firstLocRef.current) {
            firstLocRef.current.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });
        }
    }, [
        firstLocRef
    ]);
    const { activeIndex , setHovered , unsetHovered  } = useHoveredIndexController();
    return loadingRowCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col transition",
        children: Array(loadingRowCount).fill(null).map((_, i, arr)=>// Normally do not ignore these, but this is only to set a hover style and has no a11y implication
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "list-none ".concat(getBorder(i, activeIndex, arr.length, hideBorders)),
                onMouseEnter: ()=>setHovered(i),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow/* default */.Z, {
                    rank: i + 1,
                    cypressKey: "".concat(keyPrefix, "-").concat(i, "-loading"),
                    result: blankResult,
                    variant: rowVariant,
                    isLoading: true
                })
            }, getRowKey(keyPrefix, i.toString())))
    }) : // Normally do not ignore these, but this is only to set a hover style and has no a11y implication
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "flex flex-col ".concat(className),
        onMouseLeave: unsetHovered,
        children: [
            boundList.map((result, i, arr)=>// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    ref: i === 0 ? firstLocRef : undefined,
                    onMouseEnter: ()=>setHovered(i),
                    className: "list-none ".concat(getBorder(i, activeIndex, arr.length + (phoneNumber ? 1 : 0), hideBorders)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: !hide,
                        appear: true,
                        disableAnimation: disableAnimation,
                        duration: transitionSpeed,
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareEntryRow/* default */.Z, {
                            cypressKey: "".concat(keyPrefix, "-").concat(result.slug),
                            rank: i + 1,
                            result: result,
                            selectedLocation: selectedLocation,
                            query: highlightQuery,
                            variant: rowVariant,
                            shouldExpandIfTopic: shouldExpandIfTopic,
                            isLoading: false,
                            canSendApptStartEvent: canSendApptStartEvent,
                            reportClickEvent: reportClickEvent,
                            maybeToggleDialog: maybeToggleDialog,
                            maybeAddCareToTopicStack: maybeAddCareToTopicStack,
                            viewId: viewId
                        }, "".concat(keyPrefix, "-").concat(i, "-").concat(result.slug))
                    })
                }, "".concat(keyPrefix, "-").concat(i, "-").concat(result.name))),
            phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber/* PhoneNumber */.B, {
                phoneNumber: phoneNumber
            }),
            showListController && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListController, {
                onReset: onListReset
            })
        ]
    });
};
/* harmony default export */ var CareDiscoverySearch_ResultList = (/*#__PURE__*/react.memo(ResultList));

// EXTERNAL MODULE: ./src/components/v5/Region/RegionTreeSelector.tsx + 5 modules
var RegionTreeSelector = __webpack_require__(93994);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 87 modules
var Collapse_Collapse = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/hooks/usePrefersReducedMotion.ts
var usePrefersReducedMotion = __webpack_require__(80366);
// EXTERNAL MODULE: ./src/page-containers/get-care/components/ScrollContainer.tsx
var ScrollContainer = __webpack_require__(86498);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(69468);
// EXTERNAL MODULE: ./src/utils/cloneChildren.ts
var cloneChildren = __webpack_require__(91048);
;// CONCATENATED MODULE: ./src/components/animations/Slide.tsx




const Position = {
    LEFT: {
        transform: "translateX(-100vw)",
        opacity: 0
    },
    RIGHT: {
        transform: "translateX(100vw)",
        opacity: 0
    },
    TOP: {
        transform: "translateY(-100vh)",
        opacity: 0
    },
    BOTTOM: {
        transform: "translateY(100vh)",
        opacity: 0
    },
    STATIC: {
        transform: "none",
        opacity: 1
    }
};
var TransitionPosition;
(function(TransitionPosition) {
    TransitionPosition["LEFT"] = "left";
    TransitionPosition["RIGHT"] = "right";
    TransitionPosition["TOP"] = "top";
    TransitionPosition["BOTTOM"] = "bottom";
})(TransitionPosition || (TransitionPosition = {}));
const getOffPosition = (from)=>{
    switch(from){
        case TransitionPosition.LEFT:
            return Position.LEFT;
        case TransitionPosition.RIGHT:
            return Position.RIGHT;
        case TransitionPosition.TOP:
            return Position.TOP;
        case TransitionPosition.BOTTOM:
            return Position.BOTTOM;
        default:
            return Position.LEFT;
    }
};
const getTransitionStyles = (state, from)=>{
    const offPosition = getOffPosition(from);
    return ({
        entering: Position.STATIC,
        entered: Position.STATIC,
        exiting: offPosition,
        exited: offPosition,
        unmounted: offPosition
    })[state];
};
const Slide = (param)=>{
    let { duration =150 , from =TransitionPosition.LEFT , children , timeout =duration , ...transitionProps } = param;
    const cloneChildrenWithStyles = (state)=>(0,cloneChildren/* cloneChildren */.v)(children, ()=>({
                style: {
                    transition: "transform ".concat(duration, "ms ease-in-out, opacity ").concat(duration, "ms ease-in-out"),
                    ...getTransitionStyles(state, from)
                }
            }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
        timeout: timeout,
        ...transitionProps,
        children: cloneChildrenWithStyles
    });
};
/* harmony default export */ var animations_Slide = (/*#__PURE__*/react.memo(Slide));

// EXTERNAL MODULE: ./src/components/v5/Icon.tsx
var Icon = __webpack_require__(99902);
// EXTERNAL MODULE: ./src/components/v5/Location/ImageCarousel.tsx + 2 modules
var ImageCarousel = __webpack_require__(5726);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/careDiscoveryAnalytics.ts
var careDiscoveryAnalytics = __webpack_require__(9121);
;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/CloseSearchDialogButton.tsx


const CloseSearchDialogButton = (param)=>/*#__PURE__*/ {
    let { onClose , children , cypressKey  } = param;
    return (0,jsx_runtime.jsx)("button", {
        id: "close-modal",
        className: "otn brdn p-2 br2 df jcc aic cp bg-transparent top0 right0 relative z-10",
        onClick: onClose,
        "data-cy": cypressKey,
        children: children
    });
};
/* harmony default export */ var CareDiscoverySearch_CloseSearchDialogButton = (CloseSearchDialogButton);

// EXTERNAL MODULE: ./node_modules/@react-aria/focus/dist/module.js
var dist_module = __webpack_require__(39475);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(3912);
;// CONCATENATED MODULE: ./src/components/Focusable.tsx




const DEFAULT_FOCUS_STYLE = "focus-ring";
const DEFAULT_SELECTOR_STYLE = "aria-focus";
/**
 * Wrapper for react-aria `FocusRing` which automatically appends
 * focus classes for keyboard focused elements.
 */ const Focusable = (param)=>{
    let { focusStyleClass =DEFAULT_SELECTOR_STYLE , children , ...props } = param;
    const newChildProps = (0,utils_dist_module/* mergeProps */.dG)(children.props, {
        className: focusStyleClass
    });
    const child = /*#__PURE__*/ react.cloneElement(children, newChildProps);
    const focusRingProps = (0,utils_dist_module/* mergeProps */.dG)(props, {
        focusRingClass: DEFAULT_FOCUS_STYLE,
        children: child
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusRing */.tE, {
        ...focusRingProps
    });
};

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/CloseTopicExpansionButton.tsx



const CloseTopicExpansionButton = (param)=>/*#__PURE__*/ {
    let { onClick , children , cypressKey  } = param;
    return (0,jsx_runtime.jsx)(Focusable, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: onClick,
            className: "border-none outline-none bg-transparent cursor-pointer p-2 flex items-center fs14 font-ir ls-3 whitespace-nowrap",
            "data-cy": cypressKey,
            children: children
        })
    });
};
/* harmony default export */ var CareDiscoverySearch_CloseTopicExpansionButton = (/*#__PURE__*/react.memo(CloseTopicExpansionButton));

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/DialogContent.tsx



const style = {
    top: "calc(15vh - 50px)"
};
const DialogContent = (props)=>{
    const mergedProps = (0,utils_dist_module/* mergeProps */.dG)({
        className: "px-4 sm:px-10 pt-5 pb-10 br2 flex flex-col gap-0.5 bg-white m-auto minw44 maxw44 minw0-sm w100vw-sm minh100vh-sm br0-sm absolute top0-f-sm left-0 right-0 overflow-hidden",
        style
    }, props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...mergedProps
    });
};
/* harmony default export */ var CareDiscoverySearch_DialogContent = (/*#__PURE__*/react.memo(DialogContent));

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/DialogTitle.tsx


const anchorToTop = "top-6 right-0 left-0 fw5-sm flex justify-center absolute font-cm-sm md:relative md:top-0 md:text-left md:block";
const DialogTitle = (param)=>/*#__PURE__*/ {
    let { className ="" , children , shouldAnchorToTop =false , ...props } = param;
    return (0,jsx_runtime.jsx)("h2", {
        className: "font-csb text-[1.25rem] md:text-[2rem] leading-none ".concat(shouldAnchorToTop ? anchorToTop : "", " ").concat(className),
        ...props,
        children: children
    });
};
/* harmony default export */ var CareDiscoverySearch_DialogTitle = (/*#__PURE__*/react.memo(DialogTitle));

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/NoResults.tsx



const NoResults = (param)=>{
    let { isNoSymptomsSearched =false  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brdb1 brd-gray100 df fdc",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "font-ir pt4 pb6 pt2-sm pb3-sm lh15",
            children: isNoSymptomsSearched ? i18n.t("No symptoms? You can still book an appointment.") : i18n.t("We couldn’t find a match but you can still book an appointment.")
        })
    });
};
/* harmony default export */ var CareDiscoverySearch_NoResults = (NoResults);

// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/SearchDialogTrigger.tsx






const SearchDialogTrigger = (param)=>{
    let { onClick  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const CARE_DISCOVERY_TOPICS_SEARCH_ENABLED = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.CARE_DISCOVERY_TOPICS_SEARCH_ENABLED */.T.CARE_DISCOVERY_TOPICS_SEARCH_ENABLED);
    return CARE_DISCOVERY_TOPICS_SEARCH_ENABLED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Focusable, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            id: "modal-trigger",
            className: "df aic brdn otn bg-gray100 p3 w100p br3 cp mb2",
            onClick: onClick,
            "data-cy": "care-discovery-search-modal-trigger",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "cIcon-search mr3 fs26 text-gray600",
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gray600 text-left self-center fs16 text-ellipsis font-ir overflow-hidden wsnw lc1 w-full",
                    children: i18n.t("Search symptoms or services")
                })
            ]
        })
    }) : // `null` causes React error. Using fragment to
    // avoid adding unnecessary elements to the DOM
    // eslint-disable-next-line
    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
};
/* harmony default export */ var CareDiscoverySearch_SearchDialogTrigger = (SearchDialogTrigger);

// EXTERNAL MODULE: ./src/queries/useFetchCareEntries.ts
var useFetchCareEntries = __webpack_require__(37239);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/getAllRelatedCares.ts
var getAllRelatedCares = __webpack_require__(88103);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(70356);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/constants/apptReasons.ts
var apptReasons = __webpack_require__(4063);
// EXTERNAL MODULE: ./src/_services/monolith/appointmentReasons.ts
var appointmentReasons = __webpack_require__(82858);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/utils/isReasonDiscoverable.ts + 1 modules
var isReasonDiscoverable = __webpack_require__(79761);
// EXTERNAL MODULE: ./src/utils/promise/tee.ts
var tee = __webpack_require__(35721);
;// CONCATENATED MODULE: ./src/hooks/useLoadApptReasons.ts





const selectApptReasons = (state)=>state.config.reasons;
const pickApptReason = (reason)=>({
        id: reason.id,
        slug: reason.slug,
        name: reason.name,
        iconName: reason.iconName,
        description: reason.description,
        specialtyIds: reason.specialtyIds,
        newPatientDuration: reason.newPatientDuration,
        supportsVideoVisit: reason.supportsVideoVisit,
        supportsInstantVisit: reason.supportsInstantVisit,
        practiceApptReasonSpecialties: reason.practiceApptReasonSpecialties,
        code: reason.code
    });
const useLoadApptReasons = ()=>{
    const [state, setState] = (0,react.useState)([]);
    const dispatch = (0,store/* useTypedDispatch */.zL)();
    const maybeAlreadyLoadedReasons = (0,store/* useTypedSelector */.ix)(selectApptReasons);
    const reasonsAreAlreadyLoaded = Array.isArray(maybeAlreadyLoadedReasons) && maybeAlreadyLoadedReasons.length > 0;
    (0,react.useEffect)(()=>{
        if (!reasonsAreAlreadyLoaded) {
            (0,appointmentReasons/* loadAppointmentReasons */.J)().then((reasons)=>reasons.filter((reason)=>(0,isReasonDiscoverable/* isReasonDiscoverable */.t)(reason))).then((reasons)=>reasons.map(pickApptReason)).then((0,tee/* default */.Z)((reasons)=>dispatch(store/* actions.setConfig */.Nw.setConfig({
                    reasons
                })))).then(setState);
        }
    }, [
        reasonsAreAlreadyLoaded
    ]);
    return state;
};

// EXTERNAL MODULE: ./src/hooks/useQueryController.ts + 1 modules
var useQueryController = __webpack_require__(75290);
// EXTERNAL MODULE: ./src/utils/cms/cms.ts
var cms = __webpack_require__(43367);
// EXTERNAL MODULE: ./src/utils/noOp.ts
var noOp = __webpack_require__(47597);
;// CONCATENATED MODULE: ./src/queries/useSearchCareEntries.ts





const useSearchCareEntriesQuery = function() {
    let query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", { skip =false , isNoSymptomsSearched =false , queryAnalyticsReporter =noOp/* noOp */.E  } = arguments.length > 1 ? arguments[1] : void 0;
    const fn = (0,react.useCallback)(()=>(isNoSymptomsSearched ? Promise.resolve([]) : (0,cms/* fetchCareEntries */.Am)(query)).then((0,tee/* default */.Z)((results)=>{
            queryAnalyticsReporter(results, results.length === 0 && query.length > 1);
        })), [
        isNoSymptomsSearched,
        query,
        queryAnalyticsReporter
    ]);
    const defaultValue = (0,react.useMemo)(()=>[], []);
    return (0,useQueryController/* useQueryController */.co)({
        fn,
        cacheKey: query,
        skip,
        initialValue: defaultValue
    });
};

// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
;// CONCATENATED MODULE: ./src/components/v5/Reason/SpecialSearchKeywords.ts
const noSymptomKeywords = [
    "none",
    "no symptom",
    "no symptoms"
];

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/useCareDiscoverySearchController.ts









const queryLengthThreshold = 2;
const useCareDiscoverySearchController = (defaultResults)=>{
    const { t  } = (0,src_i18n/* useTranslation */.$G)();
    const [query, setQuery] = (0,react.useState)("");
    const isShortQuery = query.length < queryLengthThreshold;
    const isNoSymptomsSearched = noSymptomKeywords.includes(query === null || query === void 0 ? void 0 : query.trim().toLowerCase());
    const handleQueryChange = (0,react.useMemo)(()=>debounce_default()((val)=>{
            setQuery(val);
        }, 400), []);
    const reasons = useLoadApptReasons();
    const noResultSuggestions = (0,react.useMemo)(()=>[
            {
                name: t("General urgent care visit"),
                description: "",
                appointment_reason: apptReasons/* ApptReasonId.GENERAL_URGENT_CARE */.xT.GENERAL_URGENT_CARE,
                slug: "general-urgent-care-visit",
                href: (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
                    apptReasonId: apptReasons/* ApptReasonId.GENERAL_URGENT_CARE */.xT.GENERAL_URGENT_CARE
                }),
                icon: "book-appointment"
            }
        ], [
        t
    ]);
    const queryAnalyticsReporter = (0,react.useMemo)(()=>(0,careDiscoveryAnalytics/* buildSearchReporter */.AV)(query, reasons, noResultSuggestions), [
        noResultSuggestions,
        query,
        reasons
    ]);
    const searchCareEntriesQuery = useSearchCareEntriesQuery(query, {
        skip: isShortQuery,
        isNoSymptomsSearched,
        queryAnalyticsReporter
    });
    const emptyData = searchCareEntriesQuery.data.length === 0;
    const showDefaultResults = isShortQuery;
    const showNoResults = emptyData && !showDefaultResults && searchCareEntriesQuery.isSettled;
    const resultsToRender = showNoResults ? noResultSuggestions : showDefaultResults ? defaultResults : searchCareEntriesQuery.data;
    return {
        query,
        setQuery,
        isShortQuery,
        isNoSymptomsSearched,
        handleQueryChange,
        searchCareEntriesQuery,
        showNoResults,
        showDefaultResults,
        emptyData,
        resultsToRender
    };
};

// EXTERNAL MODULE: ./src/constants/cares.ts
var cares = __webpack_require__(94700);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/useTopicStack.tsx






const initialState = {
    stack: [],
    direction: "add"
};
const MAX_STACK_SIZE = 4;
/**
 * When feature is enabled, these topics should always expand
 */ const alwaysExpand = [
    cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
    cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
    cares/* CareSlug.COVID_TESTING */.s.COVID_TESTING
];
/**
 * This can be moved to a better place after experiment conclusion.
 * For now it makes sense to couple it with the stack because it relies on its output.
 */ const getTitleAndDescriptionOverride = (t, slug)=>({
        title: slug === cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING ? t("Which travel test do you need?") : slug === cares/* CareSlug.COVID_TESTING */.s.COVID_TESTING ? t("Which COVID test do you need?") : undefined,
        desciption: slug === cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING ? t("Patients are responsible for verifying which test meets the travel requirements for their destination. Travel testing is recommended for asymptomatic patients, and is not covered by insurance.") : undefined,
        variant: slug === cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING || slug === cares/* CareSlug.COVID_TESTING */.s.COVID_TESTING ? CareEntryRow/* CareEntryRowVariant.MD */.s.MD : CareEntryRow/* CareEntryRowVariant.SM */.s.SM
    });
const areRecursiveTopicsEnabled = (pathname)=>pathname === _constants/* v5Pages.home */.Td.home || pathname === _constants/* v5Pages.clinicDetails */.Td.clinicDetails;
const useAreRecursiveTopicsEnabled = ()=>{
    const { pathname  } = (0,router.useRouter)();
    return areRecursiveTopicsEnabled(pathname);
};
const shouldExpandTopic = (slug, topicStackLength, hasRelatedCares, pathname)=>{
    if (!hasRelatedCares) {
        return false;
    }
    switch(pathname){
        case _constants/* v5Pages.clinicDetails */.Td.clinicDetails:
            return Boolean(topicStackLength < MAX_STACK_SIZE || topicStackLength < 1);
        case _constants/* v5Pages.home */.Td.home:
            return Boolean(alwaysExpand.includes(slug));
        default:
            return false;
    }
};
const useTopicStack = ()=>{
    const { t  } = (0,src_i18n/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const [{ stack , direction  }, setState] = (0,react.useState)(initialState);
    const topOfStack = stack[stack.length - 1];
    const reset = (0,react.useCallback)(()=>setState(initialState), [
        setState
    ]);
    const add = (0,react.useCallback)((care)=>{
        setState((state)=>({
                stack: [
                    ...state.stack,
                    care
                ],
                direction: "add"
            }));
    }, []);
    const maybeAddToStack = (0,react.useCallback)((slug, hasRelatedCares)=>{
        if (shouldExpandTopic(slug, stack.length, hasRelatedCares, pathname)) {
            return add;
        }
    }, [
        add,
        pathname,
        stack.length
    ]);
    const pop = (0,react.useCallback)(()=>{
        setState((state)=>({
                stack: state.stack.length === 0 ? state.stack : state.stack.slice(0, state.stack.length - 1),
                direction: "pop"
            }));
    }, []);
    return (0,react.useMemo)(()=>{
        return {
            ...areRecursiveTopicsEnabled(pathname) && getTitleAndDescriptionOverride(t, topOfStack === null || topOfStack === void 0 ? void 0 : topOfStack.slug),
            stack,
            direction,
            isEmpty: stack.length === 0,
            reset,
            maybeAddToStack,
            pop
        };
    }, [
        pathname,
        t,
        topOfStack === null || topOfStack === void 0 ? void 0 : topOfStack.slug,
        stack.length,
        direction,
        reset,
        maybeAddToStack,
        pop
    ]);
};

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/TopicScreen.tsx













const emptyList = [];
const TopicScreen = (param)=>{
    let { care , selectedLocation , disableExpansion , in: _in , maybeToggleDialog , maybeAddCareToTopicStack , careEntryRowVariant , isParentSearchActive , from , viewId  } = param;
    const { t  } = (0,src_i18n/* useTranslation */.$G)();
    const shouldShowSearch = useAreRecursiveTopicsEnabled() && (0,getAllRelatedCares/* getAllRelatedCares */.M)(care).length > 8;
    const relatedTopicSlugs = (0,react.useMemo)(()=>{
        var _care_related_topics;
        return ((_care_related_topics = care.related_topics) === null || _care_related_topics === void 0 ? void 0 : _care_related_topics.map((relatedTopic)=>relatedTopic.slug)) || emptyList;
    }, [
        care.related_topics
    ]);
    const careEntriesQuery = (0,useFetchCareEntries/* useFetchCareEntries */.S)(relatedTopicSlugs, {
        skip: disableExpansion
    });
    const careEntries = (0,react.useMemo)(()=>[
            ...careEntriesQuery.data,
            ...care.cares || []
        ], [
        care.cares,
        careEntriesQuery.data
    ]);
    const { isNoSymptomsSearched , handleQueryChange , searchCareEntriesQuery , showDefaultResults , showNoResults , resultsToRender  } = useCareDiscoverySearchController(careEntries);
    const loadingRowCount = showDefaultResults && careEntriesQuery.isLoading ? relatedTopicSlugs.length : searchCareEntriesQuery.isLoading ? 5 : undefined;
    const reportClickEvent = isParentSearchActive || !showDefaultResults ? (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("searched") : (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("base");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animations_Slide, {
        from: from,
        in: _in,
        duration: 125,
        timeout: 0,
        appear: true,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-cy": "topic-expansion-".concat(care.slug),
            children: [
                shouldShowSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                    onChange: handleQueryChange,
                    icon: "cIcon-search -ml-2 mr1 fs28-f",
                    placeholder: t("Search symptoms or services"),
                    ariaLabel: t("Search symptoms or services"),
                    "data-cy": "topic-expansion-".concat(care.slug, "-discovery-search-input")
                }),
                showDefaultResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fs12 font-mr ttu gray600 pl-2 block pt-3",
                    children: care.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse_Collapse/* default */.Z, {
                    in: showNoResults,
                    unmountOnExit: true,
                    appear: true,
                    timeout: 125,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_NoResults, {
                        isNoSymptomsSearched: isNoSymptomsSearched
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_ResultList, {
                    keyPrefix: "topic-expansion-results-".concat(care.slug),
                    selectedLocation: selectedLocation,
                    careEntries: resultsToRender,
                    loadingRowCount: loadingRowCount,
                    transitionSpeed: 0,
                    hideListController: true,
                    rowVariant: careEntryRowVariant,
                    hideBorders: true,
                    // random string toggles off the bold state
                    highlightQuery: "j22982jv9jvqa238vj29q",
                    className: "mt-2 gap-1",
                    reportClickEvent: reportClickEvent,
                    maybeToggleDialog: maybeToggleDialog,
                    maybeAddCareToTopicStack: maybeAddCareToTopicStack,
                    viewId: viewId
                })
            ]
        })
    });
};
/* harmony default export */ var CareDiscoverySearch_TopicScreen = (/*#__PURE__*/react.memo(TopicScreen));

;// CONCATENATED MODULE: ./src/components/v5/Reason/CareDiscoverySearch/CareDiscoverySearch.tsx


























const CareDiscoverySearch = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { defaultResults =[] , dialogTitle , hideHeadline , defaultResultsLoadingCount =0 , hideRegionSelector =false , headerImages , selectedLocation , isSearchEnabled =true , defaultListRowVariant =CareEntryRow/* CareEntryRowVariant.LG */.s.LG , hideDefaultListController =false , hideDefaultListGradient =false , phoneNumber , canSendApptStartEvent =false , viewId  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const { query , setQuery , isShortQuery , isNoSymptomsSearched , handleQueryChange , searchCareEntriesQuery , showDefaultResults , showNoResults , resultsToRender  } = useCareDiscoverySearchController(defaultResults);
    const topicExpansionStack = useTopicStack();
    const onStateChange = (0,react.useCallback)((isOpen)=>{
        if (!isOpen) {
            setQuery("");
            topicExpansionStack.reset();
        }
    }, [
        setQuery,
        topicExpansionStack
    ]);
    const { state: dialog , Dialog  } = (0,useDialog/* useDialog */.R)({
        title: "search-dialog",
        blurBackdrop: true,
        isTitleHidden: true,
        isFullWidth: true,
        onStateChange
    });
    const maybeToggleDialog = (0,react.useCallback)((shouldRedirect)=>{
        if (!shouldRedirect && dialog.isClosed) {
            dialog.open();
        }
        if (shouldRedirect && dialog.isOpen) {
            setTimeout(dialog.close, 750);
        }
    }, // Do not include the `dialog` reference as it changes on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dialog.isClosed,
        dialog.open,
        dialog.isOpen,
        dialog.close
    ]);
    const shouldReduceMotion = (0,usePrefersReducedMotion/* usePrefersReducedMotion */.T)();
    const transitionSpeed = shouldReduceMotion ? 0.1 : 200;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        "data-cy": "care-discovery-search",
        children: [
            !hideHeadline && /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_DialogTitle, {
                className: "block text-left mb-4",
                children: dialogTitle
            }),
            !hideRegionSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-ml-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTreeSelector/* default */.Z, {})
            }),
            headerImages && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCarousel/* default */.Z, {
                images: headerImages,
                imageWindowWidth: isSm ? "110%" : "112.5%",
                imageScaleFactor: isSm ? 1.2 : 0.4
            }),
            isSearchEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_SearchDialogTrigger, {
                        onClick: dialog.open
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse_Collapse/* default */.Z, {
                            in: true,
                            appear: true,
                            timeout: transitionSpeed,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CareDiscoverySearch_DialogContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[calc(100%+1rem)] mb-2 self-center flex relative justify-between flex-row-reverse z-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CareDiscoverySearch_CloseSearchDialogButton, {
                                                onClose: dialog.close,
                                                cypressKey: "close-search-dialog",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        icon: "close1",
                                                        className: "gray800 text-[1.125rem]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "visually-hidden",
                                                        children: i18n.t("Close modal")
                                                    })
                                                ]
                                            }),
                                            !topicExpansionStack.isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_CloseTopicExpansionButton, {
                                                onClick: topicExpansionStack.pop,
                                                cypressKey: "close-topic-expansion",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    icon: "chevron-left",
                                                    className: "gray800 text-[1.125rem]"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_DialogTitle, {
                                        shouldAnchorToTop: true,
                                        className: "mb-6",
                                        "data-cy": "care-discovery-dialog-title",
                                        children: topicExpansionStack.title || i18n.t("What brings you in?")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(animations_Slide, {
                                        in: Boolean(topicExpansionStack.desciption),
                                        from: topicExpansionStack.direction === "add" ? TransitionPosition.RIGHT : TransitionPosition.LEFT,
                                        duration: 125,
                                        unmountOnExit: true,
                                        appear: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-ir",
                                            "data-cy": "care-discovery-modal-description",
                                            children: topicExpansionStack.desciption
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse_Collapse/* default */.Z, {
                                        in: topicExpansionStack.isEmpty,
                                        children: [
                                            !hideRegionSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "-ml-2 df mb1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTreeSelector/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                                onChange: handleQueryChange,
                                                icon: "cIcon-search -ml-2 mr1 fs28-f",
                                                placeholder: i18n.t("Search symptoms or services"),
                                                ariaLabel: i18n.t("Search symptoms or services"),
                                                autoFocus: true,
                                                "data-cy": "discovery-search-input"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse_Collapse/* default */.Z, {
                                        in: showNoResults,
                                        unmountOnExit: true,
                                        appear: true,
                                        timeout: transitionSpeed,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_NoResults, {
                                            isNoSymptomsSearched: isNoSymptomsSearched
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollContainer/* default */.Z, {
                                        maxHeight: isSm ? "calc(100vh - 175px)" : "calc(70vh - 150px)",
                                        backgroundColor: "#ffffff",
                                        children: [
                                            topicExpansionStack.stack.map((topic, i, arr)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_TopicScreen, {
                                                    from: topicExpansionStack.direction === "add" ? TransitionPosition.RIGHT : TransitionPosition.LEFT,
                                                    in: i === arr.length - 1,
                                                    care: topic,
                                                    selectedLocation: selectedLocation,
                                                    isParentSearchActive: !showDefaultResults && Boolean(query),
                                                    maybeToggleDialog: maybeToggleDialog,
                                                    maybeAddCareToTopicStack: topicExpansionStack.maybeAddToStack,
                                                    careEntryRowVariant: topicExpansionStack.variant || CareEntryRow/* CareEntryRowVariant.SM */.s.SM,
                                                    viewId: viewId
                                                }, "topic-screen-".concat(topic.slug))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_ResultList, {
                                                keyPrefix: "search-results",
                                                loadingRowCount: searchCareEntriesQuery.isLoading ? 5 : undefined,
                                                selectedLocation: selectedLocation,
                                                hide: !topicExpansionStack.isEmpty,
                                                careEntries: resultsToRender,
                                                transitionSpeed: transitionSpeed,
                                                highlightQuery: !isShortQuery && !showNoResults && query || undefined,
                                                rowVariant: CareEntryRow/* CareEntryRowVariant.MD */.s.MD,
                                                reportClickEvent: showDefaultResults ? (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("base") : (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("searched"),
                                                maybeToggleDialog: maybeToggleDialog,
                                                maybeAddCareToTopicStack: topicExpansionStack.maybeAddToStack,
                                                viewId: viewId,
                                                hideListController: true,
                                                hideBorders: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer/* default */.Z, {
                disabled: isSm,
                maxHeight: "calc(100vh - 300px)",
                hideGradient: hideDefaultListGradient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch_ResultList, {
                    keyPrefix: "default-results",
                    selectedLocation: selectedLocation,
                    careEntries: defaultResults,
                    transitionSpeed: transitionSpeed,
                    disableAnimation: true,
                    rowVariant: defaultListRowVariant,
                    loadingRowCount: defaultResultsLoadingCount,
                    hideListController: hideDefaultListController,
                    phoneNumber: phoneNumber,
                    reportClickEvent: (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("default", pathname),
                    maybeToggleDialog: maybeToggleDialog,
                    maybeAddCareToTopicStack: topicExpansionStack.maybeAddToStack,
                    canSendApptStartEvent: canSendApptStartEvent,
                    viewId: viewId
                })
            })
        ]
    });
});
CareDiscoverySearch.displayName = "CareDiscoverySearch";
/* harmony default export */ var CareDiscoverySearch_CareDiscoverySearch = (CareDiscoverySearch);


/***/ }),

/***/ 88103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getAllRelatedCares; }
/* harmony export */ });
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);

const getAllRelatedCares = memoizee__WEBPACK_IMPORTED_MODULE_0___default()((param)=>{
    let { cares =[] , related_topics =[]  } = param;
    return [
        ...cares || [],
        ...related_topics || []
    ];
});


/***/ }),

/***/ 41519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_utils_transparent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74355);




const ShowMore = (param)=>/*#__PURE__*/ {
    let { text , flipIcon , style ={} , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        ...rest,
        className: "df aic font-ib br5 p3 brdn otn cp focus-bsDarkBlue3 contrast-tb",
        style: {
            backgroundColor: (0,src_utils_transparent__WEBPACK_IMPORTED_MODULE_2__/* .transparent */ .Z)(_c10h_colors__WEBPACK_IMPORTED_MODULE_3__.gray800, 10),
            ...style
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "fs14 gray800",
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "cIcon-dropdown-arrow-down fs12 ml2 t-200 gray800 ".concat(flipIcon ? "rotate-180" : ""),
                "aria-hidden": true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShowMore);


/***/ }),

/***/ 58922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useIOSScroller; }
/* harmony export */ });
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70356);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _components_common_Carbon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29946);
/* harmony import */ var _utils_browser_storage_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81237);




const scrollTopMargin = 1; // amount of px to scroll
/*
 overscroll-behavior is not supported on IOS 15 yet but coming to 16.
 While this isnt supported in IOS, adding a temporary hacky solution to move scroll a bit on
 load and on touch to scroll area so scroll is not locked when visitor starts scrolling down
 ref: https://caniuse.com/css-overscroll-behavior
 */ // TODO @geryit: Remove this hack when IOS 16 is a major OS
const useIOSScroller = (content)=>{
    const { osType , osVersion  } = (0,_utils_browser_storage_device__WEBPACK_IMPORTED_MODULE_3__/* .getDevice */ ._)() || {};
    const isIOS16AndBelow = osType === "IOS" && osVersion && (parseInt(osVersion, 10) || 0) < 16;
    const scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()((e)=>{
            var _e_target;
            if (e.scrollTop === 0) {
                // check if scroll is on top when content is loaded
                e.scrollTop = scrollTopMargin; // move scroll down
            } else if (((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.scrollTop) === 0) {
                // check if scroll is on top when scroll event is finished
                e.target.scrollTop = scrollTopMargin; // move scroll down
            }
        }, 150);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isIOS16AndBelow) return; // disabled in all except IOS 16 and below
        const reasonsListEl = scrollRef.current;
        if (!reasonsListEl) return;
        (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_2__/* .dly */ .h7)(()=>{
            if (reasonsListEl) {
                handleScroll(reasonsListEl);
            }
        }, 500); // wait for content to load, otherwise this wont work
        // @ts-expect-error TS2339: Property 'addEventListener' does not exist on type 'never'.
        reasonsListEl === null || reasonsListEl === void 0 ? void 0 : reasonsListEl.addEventListener("scroll", handleScroll);
        return ()=>{
            // @ts-expect-error TS2339: Property 'removeEventListener' does not exist on type 'never'.
            reasonsListEl === null || reasonsListEl === void 0 ? void 0 : reasonsListEl.removeEventListener("keydown", handleScroll);
        };
    }, [
        scrollRef,
        content,
        handleScroll,
        isIOS16AndBelow
    ]);
    // @ts-expect-error TS2322: Type 'MutableRefObject<null>' is not assignable to type 'MutableRefObject<HTMLDivElement>'.
    return scrollRef;
};


/***/ }),

/***/ 28954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qf": function() { return /* binding */ buildBookingLink; },
/* harmony export */   "WB": function() { return /* binding */ useCurrentFlowId; },
/* harmony export */   "WY": function() { return /* binding */ useParsedBookingQuery; },
/* harmony export */   "Z4": function() { return /* binding */ parseBookingQuery; },
/* harmony export */   "pq": function() { return /* binding */ getSchedulingLink; }
/* harmony export */ });
/* unused harmony export startBookingFlow */
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56722);
/* harmony import */ var _services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72714);
/* harmony import */ var _services_featureFlags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30660);
/* harmony import */ var _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93209);
/* harmony import */ var _utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34488);
/* harmony import */ var _utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1146);
/* harmony import */ var _utils_removeFalsyKeys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11280);









const parseBookingQuery = memoizee__WEBPACK_IMPORTED_MODULE_0___default()((query)=>{
    const selectedTime = (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.time);
    const originUrl = (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.originUrl);
    const slotIds = (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.slotIds);
    const initialCalendarTime = (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query["initial-calendar-time"]);
    return {
        appointmentReasonSlug: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query["appointment-reason"]),
        appointmentId: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query["appointment-id"]),
        canceled: safeBoolParse(query["canceled"]),
        canceling: safeBoolParse(query["canceling"]),
        quitting: safeBoolParse(query["quitting"]),
        locationSlug: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.location),
        selectedTime: selectedTime ? parseInt(selectedTime) : null,
        initialCalendarTime: initialCalendarTime ? parseInt(initialCalendarTime) : null,
        selectedSlotIds: slotIds ? JSON.parse(decodeURIComponent(slotIds)) : null,
        isSelectedTimeUnavailable: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.slotUnavailable) === "true",
        rescheduling: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.rescheduling) === "true",
        originUrl: originUrl ? decodeURIComponent(originUrl) : null,
        flowId: (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.flowId)
    };
}, {
    normalizer: JSON.stringify
});
const useParsedBookingQuery = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return parseBookingQuery(router.query);
};
const falsifyBadStrings = (val)=>{
    const string = "".concat(val);
    return string === "undefined" ? undefined : string === "null" ? null : string;
};
const buildBookingLink = memoizee__WEBPACK_IMPORTED_MODULE_0___default()((query)=>({
        pathname: "/booking",
        query: (0,_utils_removeFalsyKeys__WEBPACK_IMPORTED_MODULE_7__/* .removeFalsyKeys */ .q)({
            "appointment-reason": query.appointmentReasonSlug || null,
            "appointment-id": query.appointmentId || null,
            "initial-calendar-time": falsifyBadStrings(query.initialCalendarTime) || null,
            canceled: falsifyBadStrings(query.canceled) || null,
            canceling: falsifyBadStrings(query.canceling) || null,
            quitting: falsifyBadStrings(query.quitting) || null,
            location: query.locationSlug || null,
            flowId: query.flowId || null,
            slotIds: query.selectedSlotIds ? encodeURIComponent(JSON.stringify(query.selectedSlotIds)) : null,
            time: falsifyBadStrings(query.selectedTime) || null,
            slotUnavailable: falsifyBadStrings(query.isSelectedTimeUnavailable) || null,
            rescheduling: falsifyBadStrings(query.rescheduling) || null,
            originUrl: query.originUrl || null
        })
    }), {
    normalizer: JSON.stringify
});
const startBookingFlow = (query)=>{
    const flowId = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    return [
        buildBookingLink({
            ...query,
            flowId
        }),
        flowId
    ];
};
const useCurrentFlowId = ()=>{
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return (0,_utils_ignoreArrays__WEBPACK_IMPORTED_MODULE_6__/* .ignoreArrays */ .F)(query.flowId);
};
const safeBoolParse = (param)=>{
    if (param === "true") {
        return true;
    } else if (param === "false") {
        return false;
    }
    return null;
};
const getSchedulingLink = async (param)=>{
    let { pathname , specialtyIds , webSchedulingQuery , patientAppSchedulingQuery  } = param;
    const supportsUrgentCare = specialtyIds.includes(_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_4__/* .SpecialtyId.URGENT_CARE */ .mg.URGENT_CARE);
    const defaultEvaluation = {
        [_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlag.WEB_SCHEDULING_ENABLED */ .T.WEB_SCHEDULING_ENABLED]: false
    };
    const { WEB_SCHEDULING_ENABLED  } = supportsUrgentCare ? await (0,_services_featureFlags__WEBPACK_IMPORTED_MODULE_3__/* .fetchFeatureFlags */ .Vw)(defaultEvaluation, {
        overrideAttribute: {
            pathname
        }
    }) : defaultEvaluation;
    const [webSchedulingLink, flowId] = startBookingFlow(webSchedulingQuery);
    const bookingLink = WEB_SCHEDULING_ENABLED ? webSchedulingLink : (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_5__/* .getSchedulingRedirectUrl */ ._W)({
        ...patientAppSchedulingQuery,
        flowId
    });
    return {
        bookingLink,
        flowId,
        WEB_SCHEDULING_ENABLED
    };
};


/***/ }),

/***/ 86498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _hooks_useIOSScroller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58922);
/* harmony import */ var _utils_transparent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74355);





const ScrollContainer = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo((param)=>{
    let { children , containerTag ="div" , containerId , disabled , maxHeight , backgroundColor =_c10h_colors__WEBPACK_IMPORTED_MODULE_4__.gray50 , hideGradient , ...props } = param;
    const scrollRef = (0,_hooks_useIOSScroller__WEBPACK_IMPORTED_MODULE_2__/* .useIOSScroller */ .C)(children);
    const scrollConstraintStyles = disabled ? {} : {
        maxHeight,
        overflowY: "auto",
        paddingRight: 4
    };
    const inner = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(containerTag, {
            className: hideGradient ? "" : "pb8",
            id: containerId
        }, children), [
        containerTag,
        hideGradient,
        containerId,
        children
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pos-r overscroll-contain overflow-x-hidden",
                style: scrollConstraintStyles,
                ...props,
                ref: scrollRef,
                children: inner
            }),
            !hideGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "minw10 pos-r contrast-hide",
                style: {
                    width: "calc(100% - 10px)",
                    marginTop: -40,
                    height: 40,
                    backgroundColor,
                    background: "linear-gradient(0deg, ".concat(backgroundColor, ", ").concat((0,_utils_transparent__WEBPACK_IMPORTED_MODULE_3__/* .transparent */ .Z)(backgroundColor, 0), ")")
                }
            })
        ]
    });
});
ScrollContainer.displayName = "ScrollContainer";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ScrollContainer));


/***/ }),

/***/ 37239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useFetchCareEntries; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var _hooks_useQueryController__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75290);
/* harmony import */ var _utils_cms_cms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43367);



const maybeGetContent = (formattedCareEntryResponses)=>formattedCareEntryResponses.reduce((acc, next)=>!next ? acc : [
            ...acc,
            next.content
        ], []);
const useFetchCareEntries = function(slugs) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const defaultValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>[], []);
    const fn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>Promise.all(slugs.map(_utils_cms_cms__WEBPACK_IMPORTED_MODULE_2__/* .fetchCareEntry */ .WP)).then(maybeGetContent), [
        slugs
    ]);
    var _options_skip;
    return (0,_hooks_useQueryController__WEBPACK_IMPORTED_MODULE_1__/* .useQueryController */ .co)({
        fn,
        initialValue: defaultValue,
        cacheKey: JSON.stringify(slugs),
        skip: (_options_skip = options.skip) !== null && _options_skip !== void 0 ? _options_skip : false
    });
};


/***/ }),

/***/ 43367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ fetchCareEntries; },
/* harmony export */   "BW": function() { return /* binding */ CareType; },
/* harmony export */   "WP": function() { return /* binding */ fetchCareEntry; }
/* harmony export */ });
/* unused harmony exports applyCareOverride, applyRelatedTopicOverrides, isCareReason, isCareTopic, formatCareEntryResponse */
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3607);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95832);
/* harmony import */ var _constants_MsMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56776);




const fetchFields = [
    "name",
    "appointment_reason",
    "description",
    "brief_description",
    "slug",
    "cares",
    "related_topics"
];
var _options_offset;
const fetchCareEntries = (query, options)=>{
    return _services_api__WEBPACK_IMPORTED_MODULE_1__/* .api.post */ .hi.post("/hib/care/search", {
        must: [
            {
                text: query,
                type: "TYPE_CUMULATIVE",
                fuzzy: true
            }
        ],
        should: [
            {
                text: query,
                type: "TYPE_STANDARD",
                fuzzy: false
            }
        ],
        limit: (options === null || options === void 0 ? void 0 : options.limit) || 40,
        offset: (_options_offset = options === null || options === void 0 ? void 0 : options.offset) !== null && _options_offset !== void 0 ? _options_offset : 0,
        fetch_fields: fetchFields
    }).then((res)=>res.json()).then((json)=>json.hits.map((result)=>result.document)).then((results)=>results.map(applyOverrides));
};
const applyCareOverride = (param)=>{
    let { care ={} , ...overrides } = param;
    return {
        ...care,
        ...overrides.pickBy()
    };
};
const applyRelatedTopicOverrides = (param)=>{
    let { topic ={} , ...overrides } = param;
    return {
        ...topic,
        ...overrides.pickBy()
    };
};
const applyOverrides = (result)=>{
    var _result_cares, _result_related_topics;
    return {
        ...result,
        cares: ((_result_cares = result.cares) === null || _result_cares === void 0 ? void 0 : _result_cares.map(applyCareOverride)) || [],
        related_topics: ((_result_related_topics = result.related_topics) === null || _result_related_topics === void 0 ? void 0 : _result_related_topics.map(applyRelatedTopicOverrides)) || []
    };
};
const isCareReason = (content)=>// @ts-expect-error TS2322: Type 'boolean | null' is not assignable to type 'boolean'.
    content && "appointment_reason" in content;
const isCareTopic = (content)=>// @ts-expect-error TS2322: Type 'boolean | null' is not assignable to type 'boolean'.
    content && "related_topics" in content;
var CareType;
(function(CareType) {
    CareType["TOPIC"] = "TOPIC";
    CareType["REASON"] = "REASON";
})(CareType || (CareType = {}));
/**
 * This API returns both appt reason content and topic content.
 * This utility determines the type of the response
 * and applies override values for related records.
 * @param entry API response for '/hib/care/[slug]
 */ const formatCareEntryResponse = (entry)=>{
    if (isCareReason(entry)) return {
        type: CareType.REASON,
        content: entry
    };
    if (isCareTopic(entry)) return {
        type: CareType.TOPIC,
        content: applyOverrides(entry)
    };
    return null;
};
const fetchCareEntry = memoizee__WEBPACK_IMPORTED_MODULE_0___default()((slug)=>_services_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .hi.get("/hib/care/".concat(slug, "/")).then(formatCareEntryResponse).catch((err)=>{
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(err, (scope)=>{
            scope.setContext("Context", {
                slug
            });
            return scope;
        });
        return null;
    }), {
    promise: true,
    maxAge: _constants_MsMap__WEBPACK_IMPORTED_MODULE_2__/* .MsMap.ONE_MINUTE */ .I.ONE_MINUTE * 1
});


/***/ }),

/***/ 79761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ isReasonDiscoverable; }
});

;// CONCATENATED MODULE: ./src/constants/reasonCodes.ts
const ReasonCode = {
    CORONAVIRUS_SUSPICION_APPT_REASON_CODE: "VisitType:coronavirusSuspicion",
    FOR_DEV_TESTING_ONLY: "FOR_DEV_TESTING_ONLY"
};
const apptReasonEntityCodesToHide = [
    ReasonCode.CORONAVIRUS_SUSPICION_APPT_REASON_CODE,
    ReasonCode.FOR_DEV_TESTING_ONLY
];

;// CONCATENATED MODULE: ./src/utils/isReasonDiscoverable.ts

const isVisibilityConfigAcceptable = (visibilityConfig)=>!visibilityConfig || !visibilityConfig.providerOnly;
const isValidSortIndex = Number.isInteger;
const isReasonDiscoverable = function(apptReason) {
    let letNullSortIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    try {
        const isNotHiddenByCode = !apptReasonEntityCodesToHide.includes(apptReason.code);
        const hasValidSpecialty = apptReason.practiceApptReasonSpecialties.some((param)=>{
            let { sortIndex , visibilityConfig  } = param;
            return (letNullSortIndex || isValidSortIndex(apptReason.sortIndex) || isValidSortIndex(sortIndex)) && isVisibilityConfigAcceptable(visibilityConfig);
        });
        return hasValidSpecialty && isNotHiddenByCode;
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 11280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ removeFalsyKeys; }
/* harmony export */ });
const removeFalsyKeys = (obj)=>Object.fromEntries(Array.from(Object.entries(obj)).filter((param)=>{
        let [, value] = param;
        return !!value;
    }));


/***/ })

}]);